import { styled } from '@mui/material/styles'

const ButtonSet = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',

    '& > button, & > a': {
        flexBasis: 0,
        flexGrow: 1,
        minWidth: 'min-content',
        marginRight: theme.spacing(1),

        '&:last-child': {
            marginRight: 0,
        },

        [theme.breakpoints.up('sm')]: {
            flexBasis: 'initial',
            flexGrow: 0,
        },
    },
}))

export default ButtonSet
